import { createSelector } from "reselect";
import { selectCanAccessClients,
    selectCanAccessUsers,
    selectCanAccessStatistics,
    selectCanAccessDashboardManagement,
    selectCanAccessPartnerManagement,
    selectCanAccessClaimAnalysis,
    selectCanAccessCMS,
    selectCanAccessRCMStatus,
    selectCanAccessClaimAudit,
    selectCanAccessExecutionLogs,
    selectCanAccessCmsModelling,
    selectCanAccessCreditUsageReport
} from "./access";
import { selectCanAccessPricer } from "./access/pricer";
import { selectCanAccessVendorManagement } from "./access/vendorManagement";
import { selectDashboardMenus } from "./dashboards";
import { selectHasCustomClaimStatusAccess, selectHasEstimatorAccess, selectHasPriceEstimateAccess, selectHasUploadsAccess, selectIsSuperAdmin ,selectHasRCMPageAccess, selectHasSummaryDashboardAccess,selectHasPlanIdMappingAccess,selectSessionHasRcmAssignmentAccess,selectHasRcmTeamAccess,selectHasSupplementaryKnowledgeAccess,selectHasSupplementaryPromptsAccess, selectHasPatternIntelligenceAccess} from "./session";
import { selectCanAccessDashoard } from "./access/dashboard";
import { selectHasSettingsAccess,selectHasAboutAccess } from "./access/settings";
import { selectPayerIdMappingFlag } from "./settings";
import { selectFilteredData as selectProductSettings } from "../../pages/contractsPage/settingsPage";

export const selectRoleBasedMenu = createSelector(
    selectCanAccessClients,
    selectCanAccessUsers,
    selectCanAccessDashboardManagement,
    selectCanAccessStatistics,
    selectDashboardMenus,
    selectCanAccessPartnerManagement,
    selectCanAccessCMS,
    selectCanAccessPricer,
    selectCanAccessVendorManagement,
    selectIsSuperAdmin,
    selectHasUploadsAccess,
    selectCanAccessClaimAnalysis,
    selectHasEstimatorAccess,
    selectCanAccessDashoard,
    selectHasPriceEstimateAccess,
    selectHasSettingsAccess,
    selectCanAccessClaimAudit,
    selectCanAccessExecutionLogs,
    selectCanAccessCmsModelling,
    selectHasCustomClaimStatusAccess,
    selectPayerIdMappingFlag,selectHasRCMPageAccess,
    selectHasSummaryDashboardAccess,
    selectHasAboutAccess,
    selectHasPlanIdMappingAccess,
    selectHasRcmTeamAccess,
    selectCanAccessCreditUsageReport,selectProductSettings,
    selectHasSupplementaryKnowledgeAccess,
    selectHasSupplementaryPromptsAccess,
    selectHasPatternIntelligenceAccess,
    (canAccessClients, canAccessUsers, canAccessDashboardManagement, canAccessStatistics, dashboardMenus, canAccessPartnerManagement, hasCMSAccess, hasPricerAccess, hasVendorAccess, isSuperAdmin, canAccessUploads, hasCMSClaimAnalysisAccess, hasEstimatorAccess, hasDashboardAccess, hasPriceEstimateAccess, hasSettingsAccess, canAccessClaimAudit, canAccessExecutionLogs,canAccessCmsModeling, canAccessCustomClaimStatus, canPayerIdMappingAccess,canAccessRCM, canAccessSummaryDashboard,hasAboutAccess,canAccessPlanMapping,canAccessRcmAssignment,canAccessCreditUsageReport,settingsData,hasSupplementaryKnowledgeAccess,hasSupplementaryPromptsAccess, hasPatternIntelligenceAccess) => {
    const isSuperAdminOnDev = isSuperAdmin && (window.location.host==='dev.slicedhealth.com' || window.location.host.includes('localhost:'));
        // Admin SubMenu
        const adminSubMenu = [];
        if (canAccessClients) {
            adminSubMenu.push({
                title: "Clients",
                icon: "flaticon-rotate",
                page: "admin/clients",
            })
        }
        if (isSuperAdmin) {
            adminSubMenu.push({
                title: "Audit Logs",
                icon: "flaticon-rotate",
                page: "admin/audit-logs",
            })
        }
        if (isSuperAdmin) {
            adminSubMenu.push({
                title: "Partner Allowed IP/Mask",
                icon: "flaticon-rotate",
                page: "admin/partner-ip-mask",
            })
        }
        if (canAccessUsers) {
            adminSubMenu.push({
                title: "Users",
                icon: "flaticon-users",
                page: "admin/users",
            })
        }
        if(isSuperAdmin){
            adminSubMenu.push({
                title: "Credit Management",
                icon: "flaticon-graph",
                page: "admin/credits-usage",
            })
        }
        if(canAccessCreditUsageReport){
            adminSubMenu.push({
                title: "Credit Usage Report",
                icon: "flaticon-analytics",
                page: "admin/creditsusage-report",
            })
        }
       

        // if (canAccessUsers) {
        //     adminSubMenu.push({
        //         title: "Roles",
        //         icon: "flaticon-users",
        //         page: "admin/roles",
        //     })
        // }
        if (isSuperAdmin) {
            adminSubMenu.push({
                title: "Partners",
                icon: "flaticon-network",
                page: "admin/partners",
            })
        }
        if (canAccessStatistics) {
            adminSubMenu.push({
                title: "Statistics",
                icon: "flaticon-statistics",
                page: "admin/statistics/trim",
            })
        }
        if (canAccessDashboardManagement) {
            adminSubMenu.push({
                title: "Dashboards",
                icon: "flaticon-imac",
                page: "admin/dashboards",
                // submenu: [{
                //     title: "Dashboards",
                //     icon: "flaticon-graphic-1",
                //     page: "admin/dashboards",
                // },
                // {
                //     title: "Data Sources",
                //     icon: "flaticon-interface-3",
                //     page: "admin/dashboardDataSources",
                // },
                // {
                //     title: "Filters",
                //     icon: "flaticon-interface-7",
                //     page: "admin/dashboardfilters",
                // },
                // {
                //     title: "Types",
                //     icon: "flaticon-interface",
                //     page: "admin/dashboardTypes",
                // }
                // ]
            })
        }
        if (isSuperAdmin) {
            adminSubMenu.push({
                title: "API Keys",
                icon: "fas fa-key",
                page: "admin/api-key-management",
            })
        }
        if(isSuperAdmin){
            adminSubMenu.push({
                title: "API Applications",
                icon: "fas fa-key",
                page: "admin/app-id-management",
            })
        }
        if (isSuperAdmin) {
            adminSubMenu.push({
                title: "Confidence Score Triage",
                icon: "fas fa-tachometer-alt",
                page: "cms/confidence-score-triage",
            })
        }
        let dashboardMenu = [];
        if (hasDashboardAccess) {
            dashboardMenu.push({
                title: "Dashboard",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                translate: "MENU.DASHBOARD",
                bullet: "dot",
                submenu: dashboardMenus
            })
        }

        let baseMenu = {
            header: {
                self: {},
                items: []
            },
            aside: {
                self: {},
                items: [...dashboardMenu],
            }
        }



        // if (canAccessPartnerManagement) {
        //     baseMenu = {
        //         ...baseMenu,
        //         ...baseMenu.aside.items[1].submenu.push({
        //             title: "Partners",
        //             icon: "flaticon-network",
        //             page: "admin/partners",
        //         })
        //     }
        // }

        let cmsSubMenu = [];

        if(canAccessRCM)
            {
                cmsSubMenu = cmsSubMenu.concat(
                    {
                        title: "RCM Status Report",
                        icon: "flaticon-analytics",
                        page: "cms/rcm-status",
                    },
                )
            }

        if(hasCMSAccess && canAccessSummaryDashboard) {
            cmsSubMenu.push({
                title: "Summary Dashboard",
                icon: "fas fa-chart-line",
                page: "cms/summary-dashboard",
            })
        }

        if (hasCMSClaimAnalysisAccess) {
            cmsSubMenu.push({
                title: "Claim Analysis",
                icon: "flaticon-analytics",
                page: "cms/claimAnalysis",
            });
        }

        if (hasCMSClaimAnalysisAccess && hasPatternIntelligenceAccess) {
            cmsSubMenu.push({
                title: "Pattern Intelligence",
                icon: "flaticon-analytics",
                page: "cms/pattern-intelligence",
            });
        }


        if(hasCMSClaimAnalysisAccess) {
            cmsSubMenu.push({
                title: "Charge Analysis",
                icon: "flaticon-analytics",
                page: "cms/charge-analysis",
            },)
        }

        if (hasCMSClaimAnalysisAccess) {
            cmsSubMenu.push({
                title: "Claim Lookup",
                icon: "flaticon-analytics",
                page: "cms/claimLookup",
            });
        }

        let claimExecutionLogsMenu = [];
        if (isSuperAdmin || canAccessExecutionLogs) {
            claimExecutionLogsMenu.push({
                title: "Execution Logs",
                icon: "flaticon-time",
                page: "cms/executions",
            });
        }

        let claimAuditMenu = [];
        if (isSuperAdmin || canAccessClaimAudit) {
            claimAuditMenu.push({
                title: "Claim Audits",
                icon: "fas fa-diagnoses",
                page: "cms/claimAudits",
            });
            

            if(isSuperAdminOnDev)
            {
                claimAuditMenu.push({
                    title: "Old Model Simulator",
                    icon: "fas fa-calculator",
                    page: "cms/simulator",
                },
                {
                    title: "New Model Simulator",
                    icon: "fas fa-calculator",
                    page: "cms/new-simulator",
                })
            }
            
        }

        if(canAccessCmsModeling)
        {
            claimAuditMenu.push({
                title: "Contract Models",
                icon: "fas fa-clone",
                page: "cms/modeling",
            })
        }

        let cmsConfigSubMenu = [
            {
                title: "Code Services",
                icon: "flaticon-signs",
                page: "cms/codeservice",
            },

            {
                title: "Search Criteria",
                icon: "flaticon-search",
                page: "cms/criteria",
            },
            {
                title: "Modifiers",
                icon: "fas fa-edit",
                page: "cms/modifiers",
            },
            {
                title: "IPPS",
                icon: "far fa-handshake",
                page: "cms/ipps",
            },
            {
                title: "OPPS",
                icon: "far fa-handshake",
                page: "cms/opps",
            },
            {
                title: "EAPG",
                icon: "far fa-handshake",
                page: "cms/eapg",
            },
            {
                title: "Contract Families",
                icon: "flaticon-graphic-1",
                page: "cms/family",
            },
            {
                title: "Providers",
                icon: "fa fa-newspaper",
                page: "cms/providers",
            },
            {
                title: "Provider Roles",
                icon: "fa fa-file-invoice",
                page: "cms/provider-roles",
            },
        ];

        if(hasCMSAccess && canAccessCustomClaimStatus) {
            cmsConfigSubMenu.push({
                title: "Claim Statuses",
                icon: "far fa-check-circle",
                page: "cms/claimstatuses",
            });
        }
        if(canAccessRcmAssignment)
        {
            cmsConfigSubMenu.push({
                title: "RCM Teams",
                icon: "far fa-check-circle",
                page: "cms/rcm-assignment",
            });
        }
        if(hasSupplementaryPromptsAccess)
        {
            cmsConfigSubMenu.push({
                title: "Supplementary Prompts",
                icon: "fas fa-brain",
                page: "cms/supplementary-prompts",
            });
        }

        if (hasCMSClaimAnalysisAccess && hasSupplementaryKnowledgeAccess) {
            cmsConfigSubMenu.push({
                title: "IQ Knowledge Base",
                icon: "flaticon-analytics",
                page: "cms/iq-knowledge-base",
            });
        }

        const canAccessRemitPayers =
            settingsData
                ?.find(
                    (item) => item?.name?.toLowerCase() == "remit payer mapping"
                )
                ?.value?.toLowerCase() === "true";

        if (isSuperAdmin || hasCMSAccess) {
            cmsSubMenu = cmsSubMenu.concat(
                claimExecutionLogsMenu,
                {
                    title: "Contracts",
                    icon: "flaticon-graphic-1",
                    page: "cms/contracts",
                    altPage:"cms/contract"
                },
                // {
                //     title: "Contracts V2",
                //     icon: "flaticon-graphic-1",
                //     page: "cms/contracts",
                // },
                {
                    title: "Fee Schedules",
                    root: true,
                    icon: "flaticon-interface-3",
                    page: "cms/feeschedules",
                    bullet: "dot",
                    submenu: [
                        {
                            title: "Fee Schedules",
                            icon: "flaticon-interface-3",
                            page: "cms/feeschedules",
                        },
                        {
                            title: "Global Fee Schedules",
                            icon: "flaticon-interface-3",
                            page: "cms/global-feeschedules",
                        }
                    ]
                },
                // {
                //     title: "Payments",
                //     icon: "flaticon-signs",
                //     page: "contract/payments",
                // },
                {
                    title: "Facilities",
                    icon: "flaticon-placeholder-1",
                    page: "cms/facilities",
                },
                ...claimAuditMenu,
                {
                    title: "Payers",
                    root: true,
                    icon: "fas fa-university",
                    page: "cms/payers",
                    //translate: "MENU.DASHBOARD",
                    bullet: "dot",
                    submenu: [
                        (!canAccessPlanMapping && {
                            title: "Claim Payers",
                            icon: "fas fa-money-check-alt",
                            page: "cms/payers/payerinfo",
                        }),
                        (canAccessRemitPayers && {
                            title: "Remit Payers",
                            icon: "fas fa-money-bill",
                            page: "cms/payers/remitPayers",
                        }),
                        {
                            title: "Payer Contract",
                            icon: "fas fa-file-contract",
                            page: "cms/payers/contracts",
                        },
                        {
                            title: "Payer Scorecard",
                            icon: "fas fa-regular fa-clipboard-list",
                            page: "cms/payers/scorecard",
                        },
                        {
                            title: "Plan Management",
                            icon: "fas fa-regular fa-tasks",
                            page: "cms/payers/planManagement",
                        },
                       (canAccessPlanMapping && {
                            title: "Claim Payer Mapping",
                            icon: "flaticon-file",
                            page: "cms/supplemental-files",
                        })
                    ]
                },
            
                {
                    title: "Configuration",
                    root: true,
                    icon: "flaticon-settings",
                    page: "cms/codeservice",
                    bullet: "dot",
                    submenu: cmsConfigSubMenu
                }
            )
        }


        if (hasCMSClaimAnalysisAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Contract Management",
                            root: true,
                            icon: "far fa-handshake",
                            page: "contract",
                            //translate: "MENU.DASHBOARD",
                            bullet: "dot",
                            submenu: cmsSubMenu
                        }
                    ]
                }
            }
        }

        if (hasVendorAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Vendor Management",
                            root: true,
                            icon: "fas fa-store",
                            page: "vendor",
                            //translate: "MENU.DASHBOARD",
                            bullet: "dot",
                            submenu: [
                                {
                                    title: "Vendor Contracts",
                                    icon: "fas fa-file-contract",
                                    page: "vendor",
                                },
                            ]
                        }
                    ]
                }
            }
        }

        let estimatorMenu = [];
        if (hasPriceEstimateAccess) {
            estimatorMenu = [{
                title: "Charge Master",
                icon: "fas fa-dollar-sign",
                page: "estimator/chargeMaster",
            },
            {
                title: "Associated",
                root: true,
                icon: "fas fa-window-restore",
                page: "estimator/associated",
                //translate: "MENU.DASHBOARD",
                bullet: "dot",
            }
        ]
        }

        if (hasPriceEstimateAccess && canPayerIdMappingAccess) {
            estimatorMenu.push({
                title: "Payer ID Mapping",
                root: true,
                icon: "fas fa-file-medical",
                page: "estimator/payeridmapping",
                bullet: "dot",
            });
        }
        if (hasEstimatorAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: baseMenu.aside.items.concat({
                        title: "Estimator",
                        root: true,
                        icon: "fas fa-calculator",
                        page: "estimator",
                        //translate: "MENU.DASHBOARD",
                        bullet: "dot",
                        submenu: [
                            {
                                title: "Estimator",
                                icon: "fas fa-calculator",
                                page: "estimator/history",
                            },
                            ...estimatorMenu,

                             ...(hasSettingsAccess ? [{
                                title: "Branding",
                                icon: "fas fa-palette",
                                page: "configuration-branding",
                            }] : [])
                        ]
                    })
                }
            }
        }

        let pricerMenu = [
            {
                title: "Look and Feel",
                root: true,
                icon: "fas fa-palette",
                page: "pricer/brandconfiguration",
                //translate: "MENU.DASHBOARD",
                bullet: "dot",
            },
            {
                title: "Pricer Payer Contract",
                root: true,
                icon: "flaticon-settings",
                page: "pricer/payer-setup",
                //translate: "MENU.DASHBOARD",
                bullet: "dot",
            },
            {
                title: "Pricer Claim Payers",
                icon: "fas fa-money-check-alt",
                page: "pricer/claim-payers",
            },
            {
                title: "Payer Info",
                icon: "fas fa-money-check-alt",
                page: "pricer/payerInfo",
            },
            {
                title: "Charge Master",
                icon: "fas fa-dollar-sign",
                page: "pricer/chargeMaster",
            },
            {
                title: "Shoppable",
                root: true,
                icon: "fa fa-plus-square",
                page: "pricer/shoppable",
                bullet: "dot",
            },
            {
                title: "Associated",
                root: true,
                icon: "fas fa-window-restore",
                page: "pricer/associated",
                //translate: "MENU.DASHBOARD",
                bullet: "dot",
            },
            {
                title: "Negotiated Rates",
                root: true,
                icon: "far fa-check-square",
                page: "pricer/allowables",
                //translate: "MENU.DASHBOARD",
                bullet: "dot",
            },
            {
                title: "Configuration",
                root: true,
                icon: "flaticon-settings",
                page: "pricer/configuration",
                bullet: "dot",
            },
            {
                title: "Hospital Services",
                root: true,
                icon: "flaticon-medical",
                page: "pricer/hospitalservices",
                bullet: "dot",
            },
            {
                title: "MRF Modifiers",
                root: true,
                icon: "fas fa-edit",
                page: "pricer/modifiers",
                bullet: "dot",
            },
            {
                title: "Execution Logs",
                icon: "flaticon-time",
                page: "pricer/executions",
            },
            {
                title: "Pricer Statistics",
                icon: "fas fa-spinner",
                page: "pricer/progress",
            }
        ];

        if(isSuperAdmin) {
            pricerMenu.push({
                title: "Pricer Statistics Logs",
                icon: "flaticon-time",
                page: "pricer/edi-executions",
            });
        }

        if (canAccessClients || hasPricerAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Pricer",
                            root: true,
                            icon: "fas fa-dollar-sign",
                            translate: "MENU.PRICER",
                            bullet: "dot",
                            submenu: pricerMenu,
                        }
                    ]
                }
            }
        }


        // Add AI submenu inside Administration
        const aiSubMenu = [
            {
                title: "Prompt Management",
                icon: "fas fa-brain",
                page: "admin/ai/prompt-management",
            }
        ];

        // If any admin access exists, add AI submenu group
        if (canAccessClients || canAccessUsers || canAccessDashboardManagement || canAccessStatistics || isSuperAdmin) {
            adminSubMenu.push({
                title: "AI",
                icon: "fas fa-robot",
                page: "admin/ai",
                submenu: aiSubMenu,
            });
        }
        if (canAccessClients || canAccessUsers || canAccessDashboardManagement || canAccessStatistics) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Administration",
                            root: true,
                            icon: "flaticon2-gear",
                            translate: "MENU.ADMINISTRATION",
                            bullet: "dot",
                            submenu: adminSubMenu,
                        }
                    ]
                }
            };
        }

                 baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Notifications",
                            root: true,
                            icon: "fas fa-bell",
                            page: "about",
                            bullet: "dot",
                            submenu: [
                                {
                                title: "Notification Subscription Settings",
                                icon: "fas fa-bell",
                                page: "notification-subscriptions",
                            },
                              {
                                title: "All Notifications",
                                icon: "fas fa-bell",
                                page: "all-notifications",
                            }
                            ]
                        }
                    ]
                }
            }

        if (isSuperAdmin || canAccessUploads) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "File Management",
                            root: true,
                            icon: "fas fa-file",
                            page: "uploads",
                            //translate: "MENU.DASHBOARD",
                            bullet: "dot",
                            submenu: [
                                {
                                    title: "Uploads",
                                    icon: "fas fa-file-upload",
                                    page: "file-management/uploads",
                                },
                                {
                                    title: "Executions",
                                    icon: "flaticon-time",
                                    page: "file-management/fileExecutions",
                                }
                            ]
                        }
                    ]
                }
            }
        }

        if (isSuperAdmin) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Control Room",
                            root: true,
                            icon: "fas fa-laptop-house",
                            page: "controlRoom",
                            //translate: "MENU.DASHBOARD",
                            bullet: "dot",
                            submenu: [
                                {
                                    title: "Job Statistics",
                                    icon: "flaticon-statistics",
                                    page: "controlRoom/jobStatistics",
                                },
                                {
                                    title: "S3 Listeners",
                                    icon: "fas fa-assistive-listening-systems",
                                    page: "controlRoom/s3Listners",
                                },
                                {
                                    title: "Health Check",
                                    icon: "fas fa-chart-bar",
                                    page: "controlRoom/healthCheck",
                                },
                                {
                                    title: "QS Datasets",
                                    icon: "fas fa-chart-line",
                                    page: "controlRoom/qs-dataset",
                                },
                            ]
                        }
                    ]
                }
            }
        }

        if (hasSettingsAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "Settings",
                            icon: "flaticon-cogwheel-1",
                            page: "configuration-settings",
                        }
                    ]
                }
            }
        }
        
        if (hasAboutAccess) {
            baseMenu = {
                ...baseMenu,
                aside: {
                    ...baseMenu.aside,
                    items: [
                        ...baseMenu.aside.items,
                        {
                            title: "About",
                            root: true,
                            icon: "fas fa-info-circle",
                            page: "about",
                            bullet: "dot",
                            submenu: [
                                {
                                    title: "Version Updates",
                                    icon: "flaticon-layer",
                                    page: "about/version",
                                }
                            ]
                        }
                    ]
                }
            }
        }



        return baseMenu;
    }
)